import { addDisplayName, addProps, flowMax } from 'ad-hok'
import { FC } from 'react'
import { createUseStyles } from 'react-jss'
import { UserWithImages } from 'shared/src/api/types'
import cx from 'classnames'

import { Avatar } from './Avatar'
import { sansSerifFontFamily } from '../utils/styles'
import { LinkOrButton } from './LinkOrButton'
import { makeFluidCreatorUrl } from 'utils/routes'
import UserBadge from './profile/UserBadge'

const useStyles = createUseStyles({
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  username: {
    color: '#ffffff',
    fontFamily: sansSerifFontFamily,
    fontWeight: 600,
    fontSize: 14,
    lineHeight: '140%',
    paddingLeft: 12,
  },
})

interface Props {
  creator: UserWithImages
  className?: string
  showUsername?: boolean
  shadow?: boolean
  height?: number
  onClick?: () => void
}

export const Creator: FC<Props> = flowMax(
  addDisplayName('Creator'),
  addProps(({ height }) => ({
    classes: useStyles(),
    height: height ?? 64,
  })),
  ({ creator, height, showUsername, shadow, onClick, className, classes }) => (
    <LinkOrButton
      navigateTo={makeFluidCreatorUrl(creator.username)}
      onClick={onClick}
      showBackButton
      replace={!!onClick}
      className={cx(classes.container, className)}
    >
      <Avatar creator={creator} height={height} shadow={shadow} />
      {showUsername && (
        <div className={classes.username}>{creator.username}</div>
      )}
      {showUsername && <UserBadge statusLevel={creator.statusLevel} />}
    </LinkOrButton>
  )
)
